import React from 'react';
import {
  Control,
  FieldErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { PushToHrisFormValues } from '../..';
import { JobAndDepartmentRow } from './JobAndDepartmentRow';
import { ResumeRow } from './ResumeRow';
import { CoverLetterRow } from './CoverLetterRow';
import { OfficeAndWorkEmailRow } from './OfficeAndWorkEmailRow';
import { ReferenceCheckRow } from './ReferenceCheckRow';
import { BackgroundCheckRow } from './BackgroundCheck';
import { StartingDateRow } from './StartingDateRow';
import { HrisSuggestions } from '../../../../../../entities/v1/HrisSuggestions';

interface PropTypes {
  register: UseFormRegister<PushToHrisFormValues>;
  control: Control<PushToHrisFormValues>;
  getValues: UseFormGetValues<PushToHrisFormValues>;
  setValue: UseFormSetValue<PushToHrisFormValues>;
  errors: FieldErrors;
  startDate: Date;
  hrisProviderLabel: string;
  suggestions: HrisSuggestions | null;
}

export function ProfessionalInformationRows(props: PropTypes) {
  return (
    <>
      <h4 className='mb-3'>Professional Information</h4>
      <JobAndDepartmentRow
        register={props.register}
        errors={props.errors}
        control={props.control}
        setValue={props.setValue}
        hrisProviderLabel={props.hrisProviderLabel}
        jobTitleSuggestionLabel={props.suggestions?.jobTitle?.label ?? null}
        departmentSuggestionLabel={props.suggestions?.department?.label ?? null}
      />
      <ResumeRow
        getValues={props.getValues}
        setValue={props.setValue}
        register={props.register}
      />
      <CoverLetterRow
        getValues={props.getValues}
        setValue={props.setValue}
        register={props.register}
      />
      <OfficeAndWorkEmailRow
        control={props.control}
        register={props.register}
        errors={props.errors}
        hrisProviderLabel={props.hrisProviderLabel}
        officeSuggestionLabel={props.suggestions?.office?.label ?? null}
      />
      <ReferenceCheckRow
        getValues={props.getValues}
        setValue={props.setValue}
        register={props.register}
      />
      <BackgroundCheckRow
        getValues={props.getValues}
        setValue={props.setValue}
        register={props.register}
      />
      <StartingDateRow startDate={props.startDate} setValue={props.setValue} />
    </>
  );
}
